import SnakeFoods from '../libs/snakeFood';
import { Vars, DefaultVars } from '../vars';
import Snake from '../libs/snake';
import GUI from '../libs/gui'
import Player from '../libs/player';

export default {
  name: 'lessen',
  text: 'Score /2',
  show_msg: true,
  repeatability: 0.8,
  timeout: 30,
  color: "#fff",
  func: () => {}
}